import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function ComingSoon({ category }) {
  return (
    <div className="text-center py-20" data-testid="coming-soon">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-cream-warm border border-border-subtle mb-6">
        <Sparkles size={26} className="text-rose" />
      </div>
      <div className="label-eyebrow mb-3">Coming Soon</div>
      <h2 className="font-display text-3xl sm:text-4xl text-ink mb-3">
        {category} arriving soon
      </h2>
      <p className="text-ink-soft max-w-md mx-auto leading-relaxed">
        We're carefully selecting pieces that meet our standard of soft, luxurious comfort. Be the first to know — or browse our other collections.
      </p>
      <Link
        to="/"
        className="inline-block mt-8 bg-sage hover:bg-sage-dark text-cream px-8 py-4 text-xs uppercase tracking-[0.22em] font-semibold transition-colors"
        data-testid="coming-soon-back-home"
      >
        Back to Collections
      </Link>
    </div>
  );
}
